import { SplitTransaction } from '@/reducers/admin/allTransactions.slice'
import { useToggle } from '@/utils/sharedHooks'
import { Table } from '@/ui'

import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { EditableTransactionTypeLabel } from '@/components/EditableTransactionTypeLabel'
import { centsToDollars } from '@/utils/currencyHelpers'
import { TransactionCategoryLabel } from '@/components/TransactionCategoryLabel'

import { UploadDocumentType } from '@/constants/businessConstants'
import { TransactionDetailsMenu } from './TransactionDetailsMenu'
import { CellContent } from './CellContent'

// TODO: Move to v2
import FileUploadModal from '@/componentsV1/FileUpload/FileUploadModal'

interface ISplitTransactionRowProps {
  splitTransaction: SplitTransaction
  locked: boolean
  isLastSplit: boolean
  parentId: number
  isManualTransaction: boolean
}

export const SplitTransactionRow = ({
  splitTransaction,
  locked,
  isLastSplit,
  parentId,
  isManualTransaction,
}: ISplitTransactionRowProps) => {
  const [fileModalOpen, toggleFileModal] = useToggle(false)

  return (
    <>
      <Table.Row
        className={
          locked ? 'bg-stone-100 text-gray-500 cursor-not-allowed' : ''
        }
      >
        {/* DATE */}
        <Table.Cell className={isLastSplit ? undefined : 'no-border'} />

        {/* DESCRIPTION */}
        <Table.Cell className={isLastSplit ? undefined : 'no-border'} />

        {/* AMOUNT */}
        <Table.Cell className="border-t text-left">
          <CellContent locked={locked}>
            <span
              className={
                splitTransaction.splitTransactions && isLastSplit
                  ? 'half-height'
                  : ''
              }
            />
            <CurrencyFormatLabel
              value={centsToDollars(splitTransaction?.amountInCents)}
            />
          </CellContent>
        </Table.Cell>

        {/* TYPE */}
        <Table.Cell className="border-t text-center">
          <CellContent locked={locked}>
            <EditableTransactionTypeLabel transaction={splitTransaction} />
          </CellContent>
        </Table.Cell>

        {/* CATEGORY */}
        <Table.Cell className="border-t">
          <CellContent locked={locked}>
            <TransactionCategoryLabel
              variant="text"
              editable
              transaction={splitTransaction}
              filtered
              useRecategorizationModal
            />
          </CellContent>
        </Table.Cell>

        {/* ACCOUNT */}
        <Table.Cell className="border-totp" />

        {/* ICON */}
        <Table.Cell className={isLastSplit ? undefined : 'border-t'} />

        {/* ACTION MENU */}
        <Table.Cell>
          {!locked && (
            <TransactionDetailsMenu
              transaction={splitTransaction}
              toggleFileModal={toggleFileModal}
              isManualTransaction={isManualTransaction}
            />
          )}
        </Table.Cell>
      </Table.Row>

      <FileUploadModal
        open={fileModalOpen}
        close={toggleFileModal}
        documentType={UploadDocumentType.RECEIPT}
        userFacing
        extraPayload={{ transactionId: Number(parentId) }}
      />
    </>
  )
}
